import {Structure} from './structure';
import {Artwork} from "./artwork";
import {Category} from "./category";
import {Group} from "./group";

export class Database {
  _id: string;
  code: string;
  groups: Array<Group>;
  structure: Structure;
  language: string;
  artworks: Array<Artwork>;
  categories: Array<Category>;
  updated_at: Date;

  constructor(data) {

    this._id = data._id;
    this.code = data.code;
    this.groups = data.groups ? data.groups.map(group => new Group(group)) : [];
    this.language = data.language;
    this.artworks = data.artworks ? data.artworks.map(artwork => new Artwork(artwork)) : [];
    this.categories = data.categories ? data.categories.map(category => new Category(category)) : [];
    this.structure = new Structure(data.structure || {});
    this.updated_at = new Date(data.updated_at);
  }

  getObj() {
    return {
      language: this.language,
      code: this.code,
      structure: this.structure.getObj()
    }
  }
}
